module.exports = __webpack_public_path__ + "static/img/acq-4.7ec907b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acq-4.png
// module id = q5Qr
// module chunks = 1